<script setup lang="ts">
import {PdfInvoiceV2, PdfInvoiceOtherV2, PdfInvoiceLoan, PdfInvoiceIndigoCars, PdfInvoiceCompany5} from '#components'

definePageMeta({
  layout: 'pdf',
})
const route = useRoute()

const from = computed(() => {
  return route.query.from
})

const ids = computed(() => {
  return route.query.ids?.split(',').map(Number)
})

const exportParts = () => {
  return route.query.parts?.split(',').reduce((acc, part) => {
    acc[part] = true
    return acc
  },{})
}


const {data: invoiceData, pending, error} = await useAsyncData(async () => {
  const client = useClient()

  const result = await client.car.getBatchInvoiceData.mutate({
    ids: ids.value,
    clientId: +route.query?.clientId,
    invoiceData: {
      from: +from.value,
      bankId: +route.query?.bankId,
      platformMode: route.query?.platformMode,
      platformId: +route.query?.platformId,
      ...(exportParts()),
    },
  })
  return result
})

//TODO: handle error
// if (error) {
//   throw createError({
//     message: error.message,
//     statusCode: error.statusCode,
//   })
// }

const pdfComponent = computed(() => {
  switch (+from?.value) {
    case 1:
      return PdfInvoiceV2
    case 2:
      return PdfInvoiceOtherV2
    case 3:
      return PdfInvoiceLoan
    case 4:
      return PdfInvoiceIndigoCars
    case 5:
      return PdfInvoiceCompany5
    default:
      return null
  }
})

</script>

<template>
  <div>
    <Component
      :is="pdfComponent"
      v-if="pdfComponent && !pending && !error"
      :invoice-data="invoiceData"
    />
    <div v-if="!pending && error">
      {{ error }}
    </div>
  </div>
</template>

<style scoped>

</style>
